import { useMemo, useState } from 'react';
import { filterDocumentsByOverview } from '../../utils/documents.overview';
import { filterDocuments } from '../../utils/documents.helpers';

export function useDocumentsFilters(documents) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Tutti');
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState('tutti');
  const [activeOverviewFilter, setActiveOverviewFilter] = useState(null);

  const clientScopedDocuments = useMemo(
    () => filterDocuments(documents, {
      selectedClientId,
    }),
    [documents, selectedClientId]
  );

  const filteredDocumentsBeforeOverview = useMemo(
    () => filterDocuments(documents, {
      searchTerm,
      selectedCategory,
      selectedStatuses,
      selectedClientId,
    }),
    [documents, searchTerm, selectedCategory, selectedStatuses, selectedClientId]
  );

  const filteredDocuments = useMemo(
    () => filterDocumentsByOverview(filteredDocumentsBeforeOverview, activeOverviewFilter),
    [activeOverviewFilter, filteredDocumentsBeforeOverview]
  );

  function resetFilters() {
    setSearchTerm('');
    setSelectedCategory('Tutti');
    setSelectedStatuses([]);
    setActiveOverviewFilter(null);
  }

  function setOverviewFilter(filterKey, { toggle = true } = {}) {
    setActiveOverviewFilter((prev) => toggle && prev === filterKey ? null : filterKey || null);
    setSearchTerm('');
    setSelectedCategory('Tutti');
    setSelectedStatuses([]);
  }

  return {
    searchTerm,
    setSearchTerm,
    selectedCategory,
    setSelectedCategory,
    selectedStatuses,
    setSelectedStatuses,
    selectedClientId,
    setSelectedClientId,
    activeOverviewFilter,
    setOverviewFilter,
    clientScopedDocuments,
    resetFilters,
    filteredDocuments,
  };
}
